import { autoinject } from "aurelia-framework";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";

@autoinject
export class CustomerApi {

    private customerApiUrl: string = `${this.configService.config.urls.rightShipPlatformApiUrl}/api/v1/customer`;

    constructor(private requestClient: RequestClientService, private configService: ConfigService){}

    public getCustomerUserEmails(customerId: number): Promise<string[]> {
        return this.requestClient.get<string[]>(`${this.customerApiUrl}/GetCustomerUserEmails`, { customerId: customerId })
    }
}
